import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddSubtopicMobile,
  successaddSubtopicMobile,
} from "./AddSubtopicMobileSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { ISubtopicMobile } from "../../../Pages/SubtopicMobile/ISubtopicMobile";

import {
  failuredeleteSubtopicMobile,
  successdeleteSubtopicMobile,
} from "./DeleteSubtopicMobileSlice";
import {
  failurelistSubtopicMobile,
  successlistSubtopicMobile,
} from "./ListSubtopicMobileSlice";
import {
  failureEditSubtopicMobile,
  successEditSubtopicMobile,
} from "./EditSubtopicMobileSlice";

// list
const ListSubtopicMobileApi = () => {
  return api.get("/api/formula/subtopic/get");
};

export function* ListSubtopicMobileCall() {
  try {
    const response: AxiosResponse = yield call(ListSubtopicMobileApi);
    yield put(successlistSubtopicMobile(response.data));
  } catch (error) {
    yield put(failurelistSubtopicMobile(error));
  }
}

// add
const AddSubtopicMobileApi = (action: PayloadAction<ISubtopicMobile>) => {
  return api.post("/api/formula/subtopic/create", action.payload);
};

export function* AddSubtopicMobileCall(action: PayloadAction<ISubtopicMobile>) {
  try {
    const response: AxiosResponse = yield call(AddSubtopicMobileApi, action);
    yield put(successaddSubtopicMobile(response.data));
  } catch (error) {
    yield put(failureaddSubtopicMobile(error));
  }
}

// edit
const EditSubtopicMobileApi = (action: PayloadAction<ISubtopicMobile>) => {
  return api.put("/api/formula/subtopic/update", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditSubtopicMobileCall(
  action: PayloadAction<ISubtopicMobile>
) {
  try {
    const response: AxiosResponse = yield call(EditSubtopicMobileApi, action);
    yield put(successEditSubtopicMobile(response.data));
  } catch (error) {
    yield put(failureEditSubtopicMobile(error));
  }
}

// delete
const DeleteSubtopicMobileApi = (action: PayloadAction<number>) => {
  return api.delete("/api/formula/subtopic/delete", {
    params: { id: action.payload },
  });
};

export function* DeleteSubtopicMobileCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSubtopicMobileApi, action);
    yield put(successdeleteSubtopicMobile(response.data));
  } catch (error) {
    yield put(failuredeleteSubtopicMobile(error));
  }
}
